import { AxiosError } from 'axios';
import { deleteSession } from '@/shared/infrastructure/adapters/storage';

export const errorResponseHandler = (
  error: AxiosError,
): Promise<AxiosError> => {
  if (error?.response?.status === 401) {
    deleteSession('/login');
  }
  return Promise.reject(error);
};
